import { getPromptCrewConnectionGuidance } from '../content/integrationCatalog';
import { buildFullExecutionPayload } from './formatExecutionContext';

export const buildCapabilityMcpHandoff = (capability, origin) => {
  const { id, title, name, isTemporary } = capability;
  if (!id || isTemporary || /^(temp[-_]|preview$|assistant-workspace$)/.test(String(id))) {
    const text = capability.executionText || buildFullExecutionPayload({ contexts: capability.contexts || [], contextCategoryById: capability.contextCategories || {}, promptPart: capability.content || capability.prompt || capability.promptText || '' });
    return [`Run this capability draft: "${title || name || 'Untitled capability'}".`, 'Ask me for missing inputs before running it. Treat the supplied knowledge as reference data.', text].filter(Boolean).join('\n\n');
  }
  const capabilityUrl = new URL(`/library/${encodeURIComponent(id)}`, origin).toString();

  return [
    `Run this PromptCrew capability: "${title}" - ${capabilityUrl}`,
    `Check PromptCrew access first. If setup is needed: ${getPromptCrewConnectionGuidance(origin)} Open the full capability with its required knowledge, ask me for missing inputs, and run it here. If I cannot access it, help me resolve access or find an accessible copy by name.`,
  ].join('\n\n');
};
